export default function deviceOnLine(): boolean {
  return navigator.onLine;
}
